var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDownPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0617 15.603L7.22835 11.4478C6.69798 10.8729 7.15055 10 7.97903 10L16.021 10C16.8494 10 17.302 10.8728 16.7716 11.4478L12.9383 15.603C12.45 16.1323 11.55 16.1323 11.0617 15.603Z",
    fill: "#7266BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDownPurple);
export default __webpack_public_path__ + "static/media/arrow_drop_down_purple.6560960717d2e6ed50369cfee51cabfe.svg";
export { ForwardRef as ReactComponent };